import React, { Component } from "react";
import { Badge, Breadcrumb, Button, Flex, Modal, Space, Select, Row, Col, notification, Spin } from "antd";
import FilterPills from "../widgets/FilterPills";
import { Link, useSearchParams } from "react-router-dom";
import { mdiDotsHorizontalCircleOutline, mdiFileDownload, mdiFilterVariant, mdiInformationOutline, mdiMapMarkerOutline } from "@mdi/js";
import Icon from "@mdi/react";
import Headline from "../components/shared/Headline";
import LocationsApi from "../../api-services/locations-api.service";
import { Country } from "../../interfaces/country.interface";
import SeriesApi from "../../api-services/series-api.service";
import { Itinerary } from "../../interfaces/itinerary.interface";

import createDOMPurify from 'dompurify'
import LocationDropdown from "../components/shared/LocationDropdown";
import ReactMarkdown from "react-markdown";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";

const DOMPurify = createDOMPurify(window)


const bannerPath = '/iceholidays-assets/images/china_listings_cover.png';

const legends = [
  { id: "guaranteed", label: "Guaranteed", color: "#DCB062" },
  { id: "almost-guaranteed", label: "Selling Fast", color: "#23D1C0" }
]

const getColorByType = (type:string) => {
  var legend = legends.find(l => l.id == type);
  return legend ? legend.color : "#999999";
}

function withSearchParams(Component) {
  return props => <Component {...props} searchParams={useSearchParams()} />;
}

class ListingPage extends React.Component <{searchParams}> {
  locationsApi = new LocationsApi;
  seriesApi = new SeriesApi;

  state = {
    loading: true,
    countries: [],
    selectedCountry: {name: "", cities: []},
    searchParamsObj: {keyword: "", year: "", month: "", location_id: null},
    itineraries: [],
    location: {name: "", cover: ""},
    breadcrumbs: [{ title: <a href="/web">Home</a> }],
    descriptionModalOpen: false,
    itineraryModalOpen: false,
    dateModalOpen: false,
    descriptionData: "",
    fileUrlData: "",
    departureDatesData: []
  }

  constructor(props:any){
    super(props);
  }

  componentDidMount() {
    this.setSearchParamsObj();

    this.locationsApi.getCountries()
      .then(locationsData => {
        var selectedCountry = locationsData[0];
        const searchParams = this.state.searchParamsObj;
        if(searchParams.location_id){
          const country = locationsData.find(loc => loc.id == searchParams.location_id);
          if(country) selectedCountry = country;
        } 
        this.setState({countries: locationsData, selectedCountry})
        this.getItineraries(searchParams, true);
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading countries.'});
      });
    
  }

  private setSearchParamsObj(){
    const [searchParams] = this.props.searchParams;
    const {searchParamsObj} = this.state;
    searchParams.keys().forEach(key => {
      searchParamsObj[key] = searchParams.get(key);
    });
    
    const {breadcrumbs} = this.state;
    breadcrumbs[1] = {title: this.searchParamsToText()};
    this.setState({searchParamsObj, breadcrumbs});
  }


  searchParamsToText() {
    var {keyword, year, month} = this.state.searchParamsObj;
    const monthYear = (month || year) && `${month} ${year}`;
    const text = [(this.state.location?.name || keyword), monthYear].filter(val => val).join(", ");
    return <span>{ text } </span>
  }

  getLocation(locationId){
    //resets the breadcrumbs
    this.setState({breadcrumbs: [{ title: <a href="/web">Home</a> }]});

    this.locationsApi.getLocation(locationId)
      .then(locationData => {
        var locationCrumbs = this.state.breadcrumbs;
        if(locationData.ancestry?.length && locationData.ancestry?.length > 0){
          locationData.ancestry.forEach(a => {
            locationCrumbs.push({title: <span key={a.id}> {a.name} </span>})
          });
        }
        locationCrumbs.push({title: <span>{locationData.name}</span>});
        this.setState({location: locationData, breadcrumbs: locationCrumbs})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading location.'});
      });
  }

  getItineraries(searchParams, init = false){
    this.setState({loading: true});

    const locationId = searchParams.location_id;
    const storedSearchParamsStr = localStorage.getItem("searchParams");
    if(storedSearchParamsStr != null){
      const storedSearchParams = JSON.parse(storedSearchParamsStr);
      const storedLocationId = storedSearchParams.location_id;
      if(locationId != storedLocationId || (init && locationId)) this.getLocation(locationId);
    }else{
      if(locationId) this.getLocation(locationId);
    }

    this.seriesApi.getItineraries(searchParams)
      .then(itinerariesData => {
        this.setBreadcrumbs();
        this.setState({itineraries: itinerariesData})
      })
      .finally(()=>this.setState({loading: false}))
      .catch(error => {
        notification.error({ message: 'An error occured while loading itineraries.'});
      });
    

    localStorage.setItem("searchParams", JSON.stringify(searchParams));
  }

  setBreadcrumbs(){
    var breadcrumbs = this.state.breadcrumbs;
    if(breadcrumbs.length > 1){
      const {keyword, ...noKeyword} = this.state.searchParamsObj;
      const allHasValues = Object.entries(noKeyword).every(o => o[1] != "" && o[1] != null);
      if(allHasValues){
        const searchResultsCrumb = {title: <span>Search results</span>};
        if(breadcrumbs.length > 2){
          breadcrumbs[breadcrumbs.length-2] = searchResultsCrumb;
        }else{
          breadcrumbs.splice(1, 0, searchResultsCrumb);
        }
      } 

      breadcrumbs[breadcrumbs.length-1] = {title: this.searchParamsToText()};
    }

    this.setState({breadcrumbs});
  }

  showModal(modalName:string, propName: string, value: any){
    this.setState({[modalName]: true, [propName]: value});
  }

  closeModal(modalName:string) {
    this.setState({[modalName]:false});
  }

  selectCountry = (country) => {
    const selectedCountry:any = this.state.countries.find((c:Country) => c.id == country);
    if(selectedCountry){
      const searchParamsObj = this.state.searchParamsObj;
      searchParamsObj.location_id = selectedCountry.id;
      // this.getLocation(selectedCountry.id);

      this.setState({selectedCountry, searchParamsObj, loading: true});
      this.getItineraries(searchParamsObj);
    }
  }


  render(){
    const {loading, countries, selectedCountry, searchParamsObj, itineraries, location, breadcrumbs, descriptionData, fileUrlData, departureDatesData } = this.state;

    return <div id="listing-page">
    
      <Headline bannerImage={location?.cover || bannerPath} breadcrumbs={breadcrumbs}>
        <div id="listing-page_header"> 
          <Flex vertical gap={10}>
            <h1>{this.searchParamsToText()}</h1>
            <LocationDropdown initialValue={selectedCountry.name} locations={countries} selectLocation={this.selectCountry}/>
          </Flex>
        </div>
      </Headline>
      
      <div id="listing-page_body">
        <Space size={12} direction="vertical">
          <FilterPills items={selectedCountry.cities} bindLabel="name" bindValue="location_id" initialValue={searchParamsObj} selectFilter={(selected) => this.getItineraries(selected)}></FilterPills>
        </Space>

        <Spin size="large" className="loader" spinning={loading}/>
        {
          !loading && (itineraries.length > 0 ? (
            <>
            <div id="legends">
              <Space size={17}>
                {
                  legends.map(legend => <Badge key={legend.id} color={legend.color} text={legend.label} />)
                }
              </Space>
            </div>
            <div id="tours">
              <Flex vertical gap={30}>
                {
                  itineraries.map((itinerary:Itinerary) => {
                    const departureDates = itinerary.departureDate ? itinerary.departureDate.map(ddate => {
                      var type = (itinerary.guranteedDepartureDates && itinerary.guranteedDepartureDates.includes(ddate)) ?  "guaranteed" : 
                      (itinerary.almostGuaranteedDepartureDates && itinerary.almostGuaranteedDepartureDates.includes(ddate)) ?  "almost-guaranteed" : "";

                      return { type, date: ddate }
                    }) : [];

                    return (
                      <Row key={itinerary.id} className="tour">
                        <Col flex="1 0 25%" className="column">
                          <div className="tour_image"> <img src={itinerary.images[0]}/> </div>
                        </Col>
                        <Col flex="1 0 55%" className="column">
                          <div className="tour_details">
                            <Space size={20} direction="vertical" style={{ display: 'flex' }}>
                              <Space size={10} direction="vertical">
                                <div className="tour_details_title"> {itinerary.caption} </div>
                                <div className="tour_details_info"> 
                                  <span  onClick={()=>this.showModal("descriptionModalOpen", "descriptionData", itinerary.description)}><Icon path={mdiInformationOutline} size={1}/></span>
                                </div>
                                <div> 
                                  <span className="tour_details_country"> <Icon path={mdiMapMarkerOutline} size="18px" /> {itinerary.country} </span> 
                                  <span className="tour_details_code" onClick={()=>this.showModal("itineraryModalOpen", "fileUrlData", itinerary.fileUrl)}> <Icon path={mdiFileDownload} size="18px" /> {itinerary.code} </span> 
                                </div>
                              </Space>
                              <div className="tour_details_dates">
                                <Space size={6} direction="vertical" style={{ display: 'flex' }}>
                                  <label>Departure Date(s)</label>
                                  <div className="date-selector">
                                    {
                                      departureDates && departureDates.map((ddate, index) => <span key={index} style={{borderColor: getColorByType(ddate.type)}}> {ddate.date} </span>)
                                    }
                                    {
                                      departureDates.length >= 9 && <div className="show-all-dates" onClick={()=>this.showModal("dateModalOpen", "departureDatesData", departureDates)}> <Icon path={mdiDotsHorizontalCircleOutline} size="15px" /> Show All </div>
                                    }
                                  </div>
                                </Space>
                              </div>
                            </Space>
                          </div>
                        </Col>
                        <Col flex="1 0 20%" className="column">
                          <div className="tour_pricing">
                            <Space size={20} direction="vertical" align="center">
                              <Flex className="tour_pricing_details">
                                <span>From</span>
                                <span className="price">{itinerary.priceCurrency} {itinerary.price}</span>
                                <span>All In</span>
                              </Flex>
                              <Link className="select-tour" to={`/web/itinerary/${itinerary.id}`}>Select</Link>
                            </Space>
                          </div>
                        </Col>
                      </Row>
                    )
                  })
                }
              </Flex>
            </div>
            </>
          ) : <h1 id="no-tours-found">No tour package is found.</h1>)
        }


      </div>

      <Modal title="Description" open={this.state.descriptionModalOpen} onCancel={()=>this.closeModal("descriptionModalOpen")} footer={null} width={1000} centered className="tour_details_description">
        <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{descriptionData}</Markdown>
      </Modal>

      <Modal title="Itinerary" open={this.state.itineraryModalOpen} onCancel={()=>this.closeModal("itineraryModalOpen")} footer={null} width={1000} centered  className="tour_details_itinerary">
        <div id="itinerary-file"><img src={fileUrlData}/></div>
      </Modal>

      <Modal title={
        <Flex justify="space-between" align="center">
          <div className="custom-modal-header-title"> Departure Date(s) </div>
          <div className="custom-modal-header-legends">
            <Space size={17}>
              {
                legends.map(legend => <Badge key={legend.id} color={legend.color} text={legend.label} />)
              }
            </Space>
          </div>
        </Flex>
      } footer={
        <Button>Confirm</Button>
      }
      open={this.state.dateModalOpen} onCancel={()=>this.closeModal("dateModalOpen")} width={940} centered className="tour_details_all_dates">
          <div className="date-selector">
            <Space size={8} wrap>
            {
              departureDatesData && departureDatesData.map((ddate:any) => <span style={{borderColor: getColorByType(ddate.type)}}> {ddate.date} </span>)
            }
            </Space>
          </div>
      </Modal>
  </div>
  }
}


export default withSearchParams(ListingPage);